<template>
  <div class="card-cell">
    <div class="card-hd">{{cardTitle}}</div>
    <div class="card-bd">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCartCard',

  props: {
    cardTitle: {
      type: String,
      default: '超凡娱乐'
    }
  }
}
</script>

<style lang="less" scoped>
.card-cell{
  //padding-bottom: 45px;
  min-height: 200px;
  margin-bottom: 20px;
}
</style>
